import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

import { Placeholder } from "components/Placeholder";

const HoldingsPieChartPlaceholderContainer = styled.div`
  .wrapper {
    height: 100%;

    .pie-chart {
      .placeholder-glow {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .circle {
          width: 196px;
          height: 196px;
          border-radius: 50%;
        }
      }
    }

    .legend-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .placeholder-glow {
        flex: 1;
      }

      .row {
        width: 100%;
      }
    }
  }
`;

export const HoldingsPieChartPlaceholder = () => {
  return (
    <HoldingsPieChartPlaceholderContainer className="pie-chart-wrapper">
      <Row className="wrapper">
        <Col md={6} className="pie-chart">
          <Placeholder className="circle" />
        </Col>

        <Col md={6} className="legend-wrapper">
          {Array.from({ length: 3 }, (_, index) => (
            <Row key={index}>
              <Col md={4} xs={3}>
                <Placeholder col={{ lg: 12, xs: 12 }} />
              </Col>
              <Col md={4} xs={3}>
                <Placeholder col={{ lg: 12, xs: 12 }} />
              </Col>
              <Col md={4} xs={3}>
                <Placeholder col={{ lg: 12, xs: 12 }} />
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    </HoldingsPieChartPlaceholderContainer>
  );
};
